const geracao_de_arquivo_retrato_da_matricula = [
  {
    path: "/geracao-de-arquivo-de-retrato-da-matricula",
    redirect: "geracao-de-arquivo-de-retrato-da-matricula",
    meta: {
      breadCrumb:
        "Planejamento de Matrícula - Geração do Arquivo do Retrato da Matrícula",
    },
    children: [
      {
        path: "/geracao-de-arquivo-de-retrato-da-matricula",
        name: "geracao_de_arquivo_de_retrato_da_matricula",
        meta: {
          breadCrumb:
            "Planejamento de Matrícula - Geração do Arquivo do Retrato da Matrícula",
          allowedPermissions: ["matricula_inicial_geracao_arquivo_retrato"],
        },
        component: () =>
          import(
            "@/views/GeracaoDeArquivoDoRetratoDaMatricula/GeracaoDeArquivoDoRetratoDaMatriculaHome.vue"
          ),
      },
    ],
  },
];

export { geracao_de_arquivo_retrato_da_matricula };
